import React from 'react';
import { MessageCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate, useLocation } from 'react-router-dom';

export default function FloatingContactButton() {
  const navigate = useNavigate();
  const location = useLocation();
  const isMainPage = location.pathname === '/';

  const handleContactPageClick = () => {
    navigate('/contact');
  };

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <Button
        onClick={handleContactPageClick}
        className="h-14 px-6 rounded-full shadow-[var(--shadow-elegant)] hover:shadow-[var(--shadow-glow)] transition-all duration-300 hover:scale-105 bg-primary hover:bg-primary/90 text-primary-foreground group"
      >
        <div className="flex items-center gap-2">
          <MessageCircle className="h-5 w-5" />
          {isMainPage && <span className="font-medium">Contact Us</span>}
        </div>
      </Button>
    </div>
  );
}